export default "__VITE_ASSET__DTRJvGzS__"